import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useFormik, FieldArray, FormikProvider } from "formik";
import * as Yup from "yup";
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Modal } from "react-bootstrap";
import HourglassLoader from '../../../../../../Common/HourglassLoader';
const host = process.env.REACT_APP_API_SERVER
const TutorSubjectiveQuestions = () => {

    const [showModal, setShowModal] = useState(false);
    const [fileName, setFileName] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data


    useEffect(() => {
        if (!data) {
            navigate(-1)
        }
    }, [data])

    const [question_no_and_marks, setquestion_no_and_marks] = useState([
        {
            question_no: "",
            marks: "",
        },
    ]);

    const [questionIdCounter, setQuestionIdCounter] = useState(2); // Starting ID for new questions


    // Yup Validation Schema
    const validationSchema = Yup.object().shape({
        question_no_and_marks: Yup.array().of(
            Yup.object().shape({
                question_no: Yup.string()
                    .required("Question number is required")
                    .test(
                        "unique-question-no",
                        "Question numbers must be unique",
                        function (value) {
                            const questionNumbers = this.options.context.question_no_and_marks.map(
                                (q) => q.question_no
                            );
                            const count = questionNumbers.filter((num) => num === value).length;
                            return count === 1;
                        }
                    )
                    .test(
                        "valid-question-no",
                        "Question number must be between 1 and the total number of questions",
                        function (value) {
                            const totalQuestions = this.options.context.question_no_and_marks.length;
                            const numberValue = Number(value);
                            return numberValue >= 1 && numberValue <= totalQuestions;
                        }
                    ),
                marks: Yup.number()
                    .required("Marks are required")
                    .typeError("Marks must be a number")
                    .min(1, "Marks must be at least 1"),
            })
        ),
        file_name: Yup.string().required("Upload Documents"),
    });



    const formik = useFormik({
        initialValues: {
            assessment_id: data?.id,
            is_objective: 0,
            question_no_and_marks: question_no_and_marks, // Initially as an array
            file_name: null,
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                // Validate the number of questions
                if (values.question_no_and_marks.length !== data?.no_of_question) {
                    toast.error(`The number of questions should be ${data?.no_of_question}.`);
                    return;
                }

                // Validate total marks
                const totalMarks = values.question_no_and_marks.reduce((sum, question) => sum + Number(question.marks), 0);
                if (totalMarks !== data?.total_marks) {
                    toast.error(`The total marks must equal ${data?.total_marks}. Currently, it's ${totalMarks}.`);
                    return;
                }

                setSubmitting(true);

                // Sanitize the payload
                const sanitizedQuestions = values.question_no_and_marks.map(({ question_no, marks }) => ({
                    question_no,
                    marks,
                }));

                const payload = {
                    ...values,
                    question_no_and_marks: JSON.stringify(sanitizedQuestions), // Serialize the array
                };

                const config = {
                    headers: {
                        "Content-Type": "multipart/form-data", // For handling file uploads
                        "x-auth-token": localStorage.getItem("tutor-token"),
                    },
                };

                // Make the API request
                const response = await axios.post(`${host}/api/tutor/create-subjective-questions`, payload, config);

                if (response.status === 200) {
                    setSubmitting(false);
                    toast.success("Questions Submitted Successfully");
                    resetForm();
                    setShowModal(true);

                    setTimeout(() => {
                        setShowModal(false);
                        navigate("/tutor/dashboard");
                    }, 1000);
                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmitting(false);
                console.error("Error:", error);
                toast.error(error.response.data.message);
            }
        },
    });



    // Add New Session
    const addSession = () => {
        const newQuestion = {
            question_no: "",
            marks: "",
        };

        const updatedQuestions = [...formik.values.question_no_and_marks, newQuestion];
        setquestion_no_and_marks(updatedQuestions);
        formik.setFieldValue("question_no_and_marks", updatedQuestions);
    };



    const deleteSession = (index) => {
        const updatedQuestions = formik.values.question_no_and_marks.filter((_, i) => i !== index);
        setquestion_no_and_marks(updatedQuestions);
        formik.setFieldValue("question_no_and_marks", updatedQuestions);
    };



    const handleGroupFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {

            setFileName(file.name);

            formik.setFieldValue('file_name', file);
        }
    };
    

    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Add Question
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <FormikProvider value={formik}>
                                    <form onSubmit={formik.handleSubmit} >
                                        <div className="row mb-3">
                                            <div className="col-lg-12 mb-3">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5 className="mb-3">Upload Test</h5>
                                                        <div className="row">
                                                            <div className="col-lg-6 col-md-6">{fileName && <div>{fileName}</div>}</div>
                                                            <div className="col-lg-6 col-md-6 d-flex flex-column align-items-end">

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success mb-2" // Added margin-bottom for spacing
                                                                    onClick={() => document.getElementById("uploadVideo").click()}
                                                                >
                                                                    Upload
                                                                    <i className="fa-solid fa-upload ms-1" />
                                                                </button>
                                                                <input
                                                                    id="uploadVideo"
                                                                    type="file"
                                                                    accept=".pdf,.doc" // Allow only PDF and DOC files
                                                                    name="file_name"
                                                                    style={{ display: "none" }} // Hidden input
                                                                    onChange={(e) => {
                                                                        handleGroupFileChange(e);
                                                                        e.target.value = ""; // Reset the file input
                                                                    }}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.errors.file_name && (
                                                                    <div className="text-danger mt-2">
                                                                        {formik.errors.file_name}
                                                                    </div>
                                                                )}

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                        {/* Formik Form */}

                                        <div id="session-container">
                                            <FieldArray name="question_no_and_marks">
                                                {() =>
                                                    formik.values.question_no_and_marks?.map((session, index) => (
                                                        <div className="session mb-4" key={session.id}>
                                                            <div className="row mb-3">
                                                                <div className="col-lg-4 col-md-6 mb-3">
                                                                    <div className="card bg-light">
                                                                        <div className="card-body">
                                                                            <h6 className="mb-2">Question : {index + 1}</h6>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Question Number"
                                                                                name={`question_no_and_marks[${index}].question_no`}
                                                                                value={
                                                                                    formik.values.question_no_and_marks[index].question_no
                                                                                }
                                                                                onChange={formik.handleChange}
                                                                            />
                                                                            {formik.errors.question_no_and_marks?.[index]?.question_no && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.question_no_and_marks[index].question_no}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-4 col-md-6 mb-3">
                                                                    <div className="card">
                                                                        <div className="card-body">
                                                                            <h6 className="mb-2">Marks</h6>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Marks"
                                                                                name={`question_no_and_marks[${index}].marks`}
                                                                                value={formik.values.question_no_and_marks[index].marks}
                                                                                onChange={formik.handleChange}
                                                                            />
                                                                            {formik.errors.question_no_and_marks?.[index]?.marks && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.question_no_and_marks[index].marks}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Add session button */}
                                                                <div className="col-lg-12 plus-btn-sec d-flex justify-content-end">
                                                                    {formik.values.question_no_and_marks.length > 1 && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger"
                                                                            onClick={() => deleteSession(index)}
                                                                        >
                                                                            <i className="fa-solid fa-trash" />
                                                                        </button>
                                                                    )}
                                                                    {/* Delete session button */}
                                                                    {index === formik.values.question_no_and_marks.length - 1 && data?.no_of_question > formik.values.question_no_and_marks.length && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary add-session-btn mx-1"
                                                                            onClick={addSession}
                                                                        >
                                                                            <i className="fa-solid fa-plus" />
                                                                        </button>

                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </FieldArray>
                                        </div>

                                        {/* Continue Button */}
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-primary w-100">

                                                    {formik.isSubmitting ? <HourglassLoader /> : 'Continue'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </FormikProvider>
                            </main>
                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Modal */}
                <Modal className='modal' show={showModal} onHide={() => setShowModal(false)}

                >

                    {/* <div className="modal-content text-center"> */}
                    <Modal.Body className='text-center'>
                        <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                        <h4 className='text-center'>
                            We will reach you after getting approval from{" "}
                            <span className="text-primary">Admin</span>
                        </h4>
                        <Link to="/tutor/dashboard">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-primary mt-4 px-4 mb-5">
                                Okay
                            </button>
                        </Link>
                    </Modal.Body>
                    {/* </div> */}

                </Modal>
            </>
        </div>
    )
}

export default TutorSubjectiveQuestions